import React from 'react'
import styled from 'styled-components'
import type { NoyoDifferenceField } from 'enrollment-platform/api/partner-benefit-graph/noyo-differences.types'
import { CollapsibleJson } from './CollapsibleJson'
import { valuesDiffer } from './formatFieldValue'

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`

const Th = styled.th`
  text-align: left;
  padding: 8px 12px;
  border-bottom: 1px solid #f0f0f0;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 600;
`

const Td = styled.td<{ $differs?: boolean }>`
  padding: 8px 12px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: top;
  word-break: break-word;
  background: ${(props) => (props.$differs ? '#fff2f0' : 'transparent')};
`

const Empty = styled.div`
  padding: 8px 0;
  color: rgba(0, 0, 0, 0.45);
`

function FieldValue({ value }: { value: unknown }) {
  if (value === null || value === undefined) {
    return <>{'—'}</>
  }
  if (typeof value === 'object') {
    return <CollapsibleJson value={value} />
  }
  return <>{String(value)}</>
}

export function FieldsComparison({
  fields,
}: {
  fields: NoyoDifferenceField[] | undefined
}) {
  if (fields == null || fields.length === 0) {
    return <Empty>No field details</Empty>
  }

  return (
    <Table>
      <thead>
        <tr>
          <Th>Field</Th>
          <Th>SureCo</Th>
          <Th>Noyo</Th>
        </tr>
      </thead>
      <tbody>
        {fields.map((field) => {
          const differs = valuesDiffer(
            field.platform_value,
            field.carrier_value
          )
          return (
            <tr key={field.key}>
              <Td>{field.key}</Td>
              <Td $differs={differs}>
                <FieldValue value={field.platform_value} />
              </Td>
              <Td $differs={differs}>
                <FieldValue value={field.carrier_value} />
              </Td>
            </tr>
          )
        })}
      </tbody>
    </Table>
  )
}
